module.exports = __webpack_public_path__ + "static/media/pig-pink.d6c0740f.webp";